import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import * as React from 'react';
import { classNames } from '~/utils/classNames';

type ToggleGroupProps = React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Root>;
type ToggleGroupItemProps = React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Item>;

export const ToggleGroup = React.forwardRef<React.ElementRef<typeof ToggleGroupPrimitive.Root>, ToggleGroupProps>(
  ({ className, children, ...props }, ref) => (
    <ToggleGroupPrimitive.Root
      ref={ref}
      className={classNames('flex items-center justify-center gap-1 bg-bolt-ds-surfaceOne', className)}
      {...props}
    >
      {children}
    </ToggleGroupPrimitive.Root>
  ),
);

ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;

export const ToggleGroupItem = React.forwardRef<
  React.ElementRef<typeof ToggleGroupPrimitive.Item>,
  ToggleGroupItemProps
>(({ className, children, ...props }, ref) => {
  const base =
    'bg-transparent focus-visible:outline-bolt-ds-brandHighlight' +
    'inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors ' +
    'hover:bg-bolt-ds-surfaceThree hover:text-bolt-ds-textSecondary focus-visible:outline-2 ' +
    'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 ' +
    'data-[state=on]:bg-bolt-ds-surfaceTwo data-[state=on]:text-bolt-ds-textPrimary ' +
    '[&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 gap-2 ' +
    'h-9 px-2.5 min-w-9';

  return (
    <ToggleGroupPrimitive.Item ref={ref} className={classNames(base, className)} {...props}>
      {children}
    </ToggleGroupPrimitive.Item>
  );
});

ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;
